<template>
    <div class="uplimit_step_table">
        <div v-if="only_up_success==0" v-b-toggle.sidebar-right-stock @click="show_sidebar(stock_info)" v-b-popover.hover.top="" :title="stock_info['up_limit_desc']+'['+stock_info['up_limit_type']+']'" :style="getPercentFontStyleNext(stock_info['next_close_pct'])">{{stock_info['up_limit_time']+" "+stock_info['stock_name']+" "+(stock_info['next_close_pct']==0?'':stock_info['next_close_pct'])}}</div>
        <div v-else-if="only_up_success==1&&stock_info['next_close_pct']>9.5" v-b-toggle.sidebar-right-stock @click="show_sidebar(stock_info)" v-b-popover.hover.top="" :title="stock_info['up_limit_desc']+'['+stock_info['up_limit_type']+']'" :style="getPercentFontStyleNext(stock_info['next_close_pct'])">{{stock_info['up_limit_time']+" "+stock_info['stock_name']+" "+(stock_info['next_close_pct']==0?'':stock_info['next_close_pct'])}}</div>
    </div>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		},
		props: {
			stock_info:Object,
			only_up_success:{type:Number,default:0},
			// stock_name: String,
			// stock_code:String,
			// up_limit_time:{type:String,default:''},
			// is_show_market:{type:Number,default:0},
			// market:{type:Object,default:undefined}
		},
		methods: {
			show_sidebar(stock_info){
				this.$emit('show_sidebar',stock_info)
			},
			getGradientColor(start_color, end_color, percent) {
				// strip the leading # if it's there
				start_color = start_color.replace(/^\s*#|\s*$/g, '');
				end_color = end_color.replace(/^\s*#|\s*$/g, '');

				// convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
				if (start_color.length == 3) {
					start_color = start_color.replace(/(.)/g, '$1$1');
				}

				if (end_color.length == 3) {
					end_color = end_color.replace(/(.)/g, '$1$1');
				}

				// get colors
				function parse(rgb, i) {
					return parseInt(rgb.substr(i, 2), 16)
				}

				let start_r = parse(start_color, 0),
					start_g = parse(start_color, 2),
					start_b = parse(start_color, 4);

				let end_r = parse(end_color, 0),
					end_g = parse(end_color, 2),
					end_b = parse(end_color, 4);

				// calculate new color
				let r = end_r - start_r;
				let g = end_g - start_g;
				let b = end_b - start_b;

				r = ((r * percent) + start_r)
				g = ((g * percent) + start_g)
				b = ((b * percent) + start_b)

				function hex(x) {
					let h = x.toString(16).split('.')[0].toUpperCase()
					return (h.length == 1) ? '0' + h : h
				}

				return '#' + hex(r) + hex(g) + hex(b)
			},

			getPercentColor(pt) {
				if (pt >= 0) {
					if (pt > +10) {
						pt = +10;
					}
					pt = +pt / 10;
					return this.getGradientColor('#FFFFFF', '#FB1023', pt)
				} else {
					if (pt < -10) {
						pt = -10;
					}
					pt = -pt / 10;
					return this.getGradientColor('#FFFFFF', '#278B22', pt)
				}
			},

			getPercentStyle(pt) {
				return {
					'background': this.getPercentColor(pt)
				}
			},
			// 按涨跌幅获取渐变颜色(-10,+10)，适合字体
			getPercentColorFont(pt) {
				if (pt === 0) {
					return '#111111'
				}
				else if (pt > 0) {
					pt = +pt / 10
					return this.getGradientColor('#FF99CC', '#FB1023', pt)
				} else {
					if (pt < -10){ pt = -10}
					pt = -pt / 10
					return this.getGradientColor('#66FF55', '#278B22', pt)
				}
			},
            getPercentFontStyle(pt) {
                return {
                    'color': this.getPercentColorFont(pt)
                }
            },
            getPercentFontStyleNext(pt){
                const color = this.getPercentColorFont(pt)
                const val = Number(pt)
                return { 'color': color, 'fontWeight': (val>9.5 ? 'bold' : 'normal') }
            },
        }

	}
</script>

<style>
.uplimit_step_table {

}
.up-success{ font-weight: bold; }
</style>
